
import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import HeroEditor from "./HeroEditor";
import AboutEditor from "./AboutEditor";
import SDGsEditor from "./SDGsEditor";
import StoriesEditor from "./StoriesEditor";

const ContentEditor: React.FC = () => {
  const { language } = useLanguage();
  const { toast } = useToast();
  const [isSaving, setIsSaving] = useState(false);
  
  // Add a function to handle content updates
  const handleContentUpdate = (section: string, data: any) => {
    // This would typically send data to a backend API
    console.log(`${section} content updated:`, data);
    
    toast({
      title: language === "en" ? "Content Updated" : "تم تحديث المحتوى",
      description: language === "en" 
        ? `The ${section} section has been updated successfully` 
        : `تم تحديث قسم ${section} بنجاح`,
    });
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl text-palsustain-green">
            {language === "en" ? "Home Page Content Editor" : "محرر محتوى الصفحة الرئيسية"}
          </CardTitle>
          <CardDescription>
            {language === "en" 
              ? "Edit the content of different sections of the home page" 
              : "تحرير محتوى أقسام مختلفة من الصفحة الرئيسية"
            }
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="hero" className="w-full">
            <TabsList className="mb-6 grid grid-cols-4 bg-palsustain-cream border border-palsustain-green/20">
              <TabsTrigger value="hero" className="data-[state=active]:bg-palsustain-green data-[state=active]:text-white">
                {language === "en" ? "Hero Section" : "قسم البطل"}
              </TabsTrigger>
              <TabsTrigger value="about" className="data-[state=active]:bg-palsustain-green data-[state=active]:text-white">
                {language === "en" ? "About Section" : "قسم حول"}
              </TabsTrigger>
              <TabsTrigger value="sdgs" className="data-[state=active]:bg-palsustain-green data-[state=active]:text-white">
                {language === "en" ? "SDGs Section" : "قسم أهداف التنمية المستدامة"}
              </TabsTrigger>
              <TabsTrigger value="stories" className="data-[state=active]:bg-palsustain-green data-[state=active]:text-white">
                {language === "en" ? "Stories Section" : "قسم القصص"}
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="hero">
              <HeroEditor onSave={(data) => handleContentUpdate("hero", data)} />
            </TabsContent>
            
            <TabsContent value="about">
              <AboutEditor onSave={(data) => handleContentUpdate("about", data)} />
            </TabsContent>
            
            <TabsContent value="sdgs">
              <SDGsEditor onSave={(data) => handleContentUpdate("sdgs", data)} />
            </TabsContent>
            
            <TabsContent value="stories">
              <StoriesEditor />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContentEditor;
